
import React from 'react';
import { motion } from 'framer-motion';

const Testimonials: React.FC = () => {
  const reviews = [
    {
      name: "Carlos Mendoza",
      location: "Miraflores, Lima",
      text: "La calidad del acero es impresionante. El acabado espejo realmente le da un toque de lujo a mi sala. Recomendado totalmente por su durabilidad y estilo."
    },
    {
      name: "Sofía Alarcón",
      location: "San Isidro, Lima",
      text: "Buscaba algo moderno y resistente. Esta mesa superó mis expectativas. La entrega fue puntual y el producto llegó en perfectas condiciones."
    },
    {
      name: "Ricardo Torres",
      location: "Arequipa",
      text: "Excelente atención de parte de DECOMAST. El vidrio templado es bastante grueso y seguro. Se nota que es un mueble de alta gama a un precio accesible."
    }
  ];

  return (
    <section className="py-24 bg-slate-900 text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl font-bold mb-4">Lo que dicen nuestros clientes</h2>
          <div className="h-1 w-16 bg-white opacity-20 mx-auto rounded-full"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reviews.map((rev, idx) => (
            <motion.div 
              key={idx} 
              className="bg-slate-800 p-8 rounded-2xl border border-slate-700 relative"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ delay: idx * 0.2 }}
              viewport={{ once: true }}
              whileHover={{ backgroundColor: "#1e293b" }}
            >
              <i className="fa-solid fa-quote-left text-slate-700 text-4xl absolute top-6 right-6 opacity-40"></i>
              <div className="flex text-yellow-500 mb-4 space-x-1">
                {[...Array(5)].map((_, i) => <i key={i} className="fa-solid fa-star text-xs"></i>)}
              </div>
              <p className="italic text-slate-300 mb-6 leading-relaxed relative z-10">"{rev.text}"</p>
              <div>
                <p className="font-bold text-lg">{rev.name}</p>
                <p className="text-slate-500 text-sm uppercase tracking-widest">{rev.location}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
